import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getLocalizedValue } from '@grandvisionhq/utils';
import { OfferingsList } from './OfferingsList.js';

function convertToLocalizedOffering(locale, offering) {
    return swcHelpers.objectSpread({}, offering, {
        title: getLocalizedValue(offering.title, locale),
        subTitle: getLocalizedValue(offering.subTitle, locale)
    });
}
var OfferingsListContainer = (_param)=>{
    var { offerings , onSelectionChange , selectedValue  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "offerings",
        "onSelectionChange",
        "selectedValue"
    ]);
    const { locale  } = useIntl();
    const offeringItems = offerings.map(convertToLocalizedOffering.bind(null, locale));
    const handleOnChange = React__default.useCallback((sku)=>{
        const selectedOffering = offerings.find((offering)=>offering.sku === sku
        );
        selectedOffering && onSelectionChange(selectedOffering);
    }, [
        offerings,
        onSelectionChange
    ]);
    return /*#__PURE__*/ React__default.createElement(OfferingsList, swcHelpers.extends({
        offeringItems: offeringItems,
        selectedValue: selectedValue,
        onChange: handleOnChange
    }, rest));
};

export { OfferingsListContainer, convertToLocalizedOffering };
//# sourceMappingURL=OfferingsListContainer.js.map
